import axios from "axios";

export interface TogglesResponse {
    readonly [toggleName: string]: boolean;
}

export async function fetchToggles(endpoint: string): Promise<TogglesResponse> {
    const response = await axios({
        timeout: 60000,
        method: "get",
        url: endpoint
    });
    return response.data;
}
